module.exports = __webpack_public_path__ + "img/carrier_defalut.bbed689.png";